export const actions = [
  'RENAME',
  'VIEW',
  'DELETE',
  'MOVE',
  'FAVORITE',
  'MANAGE_PERMISSIONS',
  'DOWNLOAD',
];
export const MANAGE_PERMISSIONS = 'MANAGE_PERMISSIONS';
